function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.443 20.974c-1.083-1.003-1.625-2.268-1.625-3.707 0-2.921 2.167-4.404 4.107-5.755 1.67-1.134 3.16-2.137 3.16-3.838 0-1.7-1.355-3.14-4.288-3.14-2.753 0-4.739 1.222-6.273 3.053L5.5 4.317C7.802 1.613 11.277 0 15.338 0 21.026 0 24.5 2.922 24.5 6.846c0 3.62-2.527 5.363-4.784 6.89-1.715 1.22-3.294 2.267-3.294 4.011 0 .698.406 1.483.992 1.962l-3.971 1.265zM15.068 30c-1.715 0-3.16-1.395-3.16-3.052s1.445-3.053 3.16-3.053 3.159 1.396 3.159 3.053S16.783 30 15.067 30z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "5",
  y: "0",
  width: "20",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.443 20.974c-1.083-1.003-1.625-2.268-1.625-3.707 0-2.921 2.167-4.404 4.107-5.755 1.67-1.134 3.16-2.137 3.16-3.838 0-1.7-1.355-3.14-4.288-3.14-2.753 0-4.739 1.222-6.273 3.053L5.5 4.317C7.802 1.613 11.277 0 15.338 0 21.026 0 24.5 2.922 24.5 6.846c0 3.62-2.527 5.363-4.784 6.89-1.715 1.22-3.294 2.267-3.294 4.011 0 .698.406 1.483.992 1.962l-3.971 1.265zM15.068 30c-1.715 0-3.16-1.395-3.16-3.052s1.445-3.053 3.16-3.053 3.159 1.396 3.159 3.053S16.783 30 15.067 30z",
  fill: "currentColor"
}))));